// menuItems.js
import React from 'react';

export const menuItems = [
  { name: 'Private Yoga', color: '#ADD8E6', link: '#private-yoga' },
  { name: 'Corporate Wellness', color: '#FFB6C1', link: '#corporate-wellness' },
  { name: 'Health Coaching', color: '#FFFACD', link: '#health-coaching' },
];
